import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lp2-mini-lesson-info-banner',
  templateUrl: './mini-lesson-info-banner.component.html',
  styleUrls: ['./mini-lesson-info-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiniLessonInfoBannerComponent {
  @Input() title: string;
  @Input() body: string;
  @Input() iconSrc: string;
  @Input() iconAlt = '';
}



// WEBPACK FOOTER //
// ./ts/app/home/mini-lesson-section/mini-lesson-info-banner/mini-lesson-info-banner.component.ts